// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
// RxJS
import { NEVER, Observable, throwError } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { debug } from 'util';
import { environment } from '../../environments/environment';
import { LoaderService} from './loader.service';

import { MatDialog } from '@angular/material';
import { DialogsErrorsSystemComponent } from '../views/dialogs-errors-system/dialogs-errors-system.component';
/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {

    isDialogErrorOpen = false;
    nbPendingRequests = 0;

	constructor(private loaderService: LoaderService, public dialog: MatDialog) { }
	
	// intercept request and add token
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// tslint:disable-next-line:no-debugger
		// modify request
		// request = request.clone({
		// 	setHeaders: {
		// 		Authorization: `Bearer ${localStorage.getItem('accessToken')}`
		// 	}
		// });
        this.nbPendingRequests++;
    	this.loaderService.show();
		if (request.body && request.body.method && (request.body.method.indexOf('connection:connect') != -1 || request.body.method.indexOf('connection:register') != -1)){
			request = request.clone({
				setHeaders: {
					'X-CSRF-Token': environment.tokencsrf
				}
			});	
		}
		else
		{
			request = request.clone({
				setHeaders: {
					'X-AUTH-TOKEN': environment.tokenauth,
					'DELEGATION-TOKEN': environment.tokenDelegation,
				}
			});	
		}
		// console.log('--- end of request---');

		return next.handle(request).pipe(
			tap(
				event => {
                    if (event instanceof HttpResponse) {
                        if (event.status !== 200) {
                            return this.makeError('Un problème est survenu, veuillez réessayer plus tard', request, event) // apache error
                        }
                        if (!event.headers.get('Content-Type') ||
                            (event.headers.get('Content-Type').indexOf('application/') !== 0 &&
                            event.headers.get('Content-Type').indexOf('text/') !== 0 &&
                            event.headers.get('Content-Type').indexOf('image/') !== 0)) {
                            return this.makeError('Un problème est survenu, veuillez réessayer plus tard', request, event) // apache didn't return a json/pdf/docx...
                        }
/*
                        if (event.headers.get('Content-Type') != 'application/json') {
                            return this.makeError('Un problème est survenu, veuillez réessayer plus tard', request, event) // apache didn't return a json
                        }
*/
                        // @ts-ignore
                        if (event.headers.get('Version') && event.headers.get('Version') != cobham_version) {
                            return this.makeError('Version différente', request, event);
                        }

                        if (event.body.jsonrpc && event.body.jsonrpc == '2.0') {
                            if (event.body.error) {
                                if (event.body.error.data && event.body.error.data.indexOf('token') > -1) {
                                    return this.makeError('Session expirée', request, event) // session expirée
                                }
                                return this.makeError(event.body.error.message, request, event) // jsonrpc know error
                            }
                            if (event.body.result) {
                                    if (event.body.result.success === false) {
                                    return this.makeError(event.body.result.error, request, event) // jsonrpc know error
                                }
                            }
                        }
                    }
                },
				error => {
                    return this.makeError('Un problème est survenu, veuillez réessayer plus tard', request, error) // apache / proxy / network / gateway...
					// http response status code
					// console.log('----response----');
					// console.error('status code:');
					// tslint:disable-next-line:no-debugger
                    console.error(error.status);
                    console.error(error.message);
					// console.log('--- end of response---');
				}
			),
            finalize(() => {
                this.nbPendingRequests--;
                if (this.nbPendingRequests === 0) {
                    this.loaderService.hide();
                }
            })
		);
	}

    makeError(msg: String, request: any, event: any): Observable<never> {
        this.loaderService.hide()
        console.error('--------ERROR')
        console.error(msg)
        console.error(request)
        console.error(event)
        console.error('END--------')

        if (!this.isDialogErrorOpen) {
            this.isDialogErrorOpen = true;
            const dialogRef = this.dialog.open(DialogsErrorsSystemComponent, {
                panelClass:'message-dialog-supp',
                width: '100%',
                data: msg,
                autoFocus: false,
            });

            dialogRef.afterClosed().subscribe(result => {
                this.isDialogErrorOpen = false;
            });
        }

        return NEVER
    }
}
